import { useEffect, useState } from "react";
import "./SideNav.css";
import "../../theme-vars.css"; // <-- Import theme variables
import { Link } from "react-router-dom";
import { useHistory } from 'react-router-dom';
import { FaChevronDown, FaChevronRight, FaChevronUp } from 'react-icons/fa';
import { setAnalyticsPanel } from "../../Redux/actions";
import { useDispatch, useSelector } from "react-redux";
import LeadRubixLogo from "../../Assets/Images/leadrubixlogo.png";
import ShortLeadsRUbixLogo from '../../Assets/Images/shortLogoLeadsRubix.svg';
import ShortLeadsRUbixLogo1 from '../../Assets/Images/shortLogoLeadsRubix1.png';

const SideNav = (props) => {
  const dispatcher = useDispatch();
  const open = useSelector((state) => state.drawerToggle.drawerOpen);
  const history = useHistory();
  const [analyticsOpen, setAnalyticsOpen] = useState(false);
  const [leadDistributorOpen, setLeadDistributorOpen] = useState(false);
  const [leadsOpen, setLeadsOpen] = useState(false);
  const [configurationOpen, setConfigurationOpen] = useState(false);
  const [IntegrationOpen, setIntegrationOpen] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [supportOpen, setSupportOpen] = useState(false);
  const [importantToolsOpen, setImportantToolsOpen] = useState(false);
  const [userPanel, setUserPanel] = useState('Contacts');

  useEffect(() => {
    if (history.location.pathname === "/analytics") {
      setAnalyticsOpen(true);
    }
    if (history.location.pathname === "/leadDistributor" || history.location.pathname === "/leadDistributorLogic" || history.location.pathname === "/reassignList" || history.location.pathname === "/reassignLogic") {
      setLeadDistributorOpen(true);
    }
    if (history.location.pathname === "/contacts" || history.location.pathname === "/tasks" || history.location.pathname === "/callLogs" || history.location.pathname === "/booking") {
      setLeadsOpen(true);
    }
    if (history.location.pathname === "/daysConfig" || history.location.pathname === "/holidayConfig" || history.location.pathname === "/projects" || history.location.pathname === "/resources" || history.location.pathname === "/headers" || history.location.pathname === "/bookingForm") {
      setConfigurationOpen(true);
    }
    if (history.location.pathname === "/integrations" || history.location.pathname === "/api" || history.location.pathname === "/apiData") {
      setIntegrationOpen(true);
    }
    if (history.location.pathname === "/subscriptionDetails" || history.location.pathname === "/updateUserPassword" || history.location.pathname === "/addCost" || history.location.pathname === "/couponlist") {
      setSettingsOpen(true);
    }
    if (history.location.pathname === "/news" || history.location.pathname === "/faq" || history.location.pathname === "/viewHelpSupport") {
      setSupportOpen(true);
    }
    if (history.location.pathname === "/areaConverter" || history.location.pathname === "/calculator" || history.location.pathname === "/emiCalculator") {
      setImportantToolsOpen(true);
    }
  }, [history.location.pathname])

  const leadMenu = [
    {
      text: "Analytics",
      icon: "icons/analytics-svgrepo-com.svg",
      link: "/analytics",
      subMenu: [
        {
          text: "Contacts Analytics",
          icon: "icons/data-analytics.png",
          panel: "Contacts"
        },
        {
          text: "Tasks Analytics",
          icon: "icons/data-analytics.png",
          panel: "Tasks"
        },
        {
          text: "Call Logs Analytics",
          icon: "icons/data-analytics.png",
          panel: "Call Logs"
        }

      ]
    },
    {
      text: "Leads",
      icon: "icons/contacts-svgrepo-com.svg",
      link: "/",
      subMenu: [
        {
          text: "Contacts List",
          icon: "icons/logicIcon.png",
          link: "/",
          LeadsShow: true
        },
        {
          text: "Tasks List",
          icon: "icons/tasks-list-svgrepo-com.svg",
          link: "/tasks",
          LeadsShow: true
        },
        {
          text: "Call Logs List",
          icon: "icons/call-svgrepo-com.svg",
          link: "/callLogs",
          LeadsShow: true
        },
        {
          text: "Bookings List",
          icon: "icons/book-svgrepo-com.svg",
          link: "/booking",
          LeadsShow: true
        },
      ]
    },
    {
      text: "Support",
      icon: "icons/contacts-svgrepo-com.svg",
      link: "/news",
      subMenu: [
        {
          text: "News List",
          icon: "icons/news-svgrepo-com.svg",
          link: "/news",
          SupportShow: true
        },
        {
          text: "FAQ List",
          icon: "icons/about-faq-help-question-svgrepo-com.svg",
          link: "/faq",
          SupportShow: true
        },
        {
          text: "Help & Support",
          icon: "icons/credit-card-svgrepo-com.svg",
          link: "/viewHelpSupport",
          SupportShow: true
        },
      ]
    },
    {
      text: "Important Tools",
      icon: "icons/contacts-svgrepo-com.svg",
      link: "/areaConverter",
      subMenu: [
        {
          text: "Area Converter",
          icon: "icons/covarea-removebg-preview.png",
          link: "/areaConverter",
          ImportantShow: true
        },
        {
          text: "Calculator",
          icon: "icons/cal-removebg-preview.png",
          link: "/calculator",
          ImportantShow: true
        },
        {
          text: "EMI Calculator",
          icon: "icons/emi.png",
          link: "/emiCalculator",
          ImportantShow: true
        }
      ]
    }
  ];

  const replicateAdminMenu = [
    {
      text: "Analytics",
      icon: "icons/analytics-svgrepo-com.svg",
      link: "/analytics",
    },
    {
      text: "Leads",
      icon: "icons/contacts-svgrepo-com.svg",
      link: "/",
      subMenu: [
        {
          text: "Contacts List",
          icon: "icons/logicIcon.png",
          link: "/",
          LeadsShow: true
        },
        {
          text: "Tasks List",
          icon: "icons/tasks-list-svgrepo-com.svg",
          link: "/tasks",
          LeadsShow: true
        },
        {
          text: "Call Logs List",
          icon: "icons/call-svgrepo-com.svg",
          link: "/callLogs",
          LeadsShow: true
        },
        {
          text: "Bookings List",
          icon: "icons/book-svgrepo-com.svg",
          link: "/booking",
          LeadsShow: true
        },
        {
          text: "Sorted list ",
          icon: "icons/book-svgrepo-com.svg",
          link: "/sorted",
          LeadsShow: true
        },
      ]
    },
    {
      text: "Configuration",
      icon: "icons/contacts-svgrepo-com.svg",
      link: "/projects",
      subMenu: [
        {
          text: "Projects List",
          icon: "icons/buildings-svgrepo-com.svg",
          link: "/projects",
          ConfigurationShow: true
        },
        {
          text: "API List",
          icon: "icons/cloud-upload-svgrepo-com.svg",
          link: "/apis",
          ConfigurationShow: true
        },
      ]
    },
    {
      text: "Support",
      icon: "icons/contacts-svgrepo-com.svg",
      link: "/news",
      subMenu: [
        {
          text: "News List",
          icon: "icons/news-svgrepo-com.svg",
          link: "/news",
          SupportShow: true
        },
        {
          text: "FAQ List",
          icon: "icons/about-faq-help-question-svgrepo-com.svg",
          link: "/faq",
          SupportShow: true
        }
      ]
    },
  ];

  const adminMenu = [
    {
      text: "Analytics",
      icon: "icons/analytics-svgrepo-com.svg",
      link: "/analytics",
    },
    {
      text: "Organization",
      icon: "icons/buildings-svgrepo-com.svg",
      link: "/",
    },
    {
      text: "User List",
      icon: "icons/profile-image-round-svgrepo-com.svg",
      link: "/userlist",
    },
    {
      text: "Leads",
      icon: "icons/contacts-svgrepo-com.svg",
      link: "/contacts",
      subMenu: [
        {
          text: "Contacts List",
          icon: "icons/logicIcon.png",
          link: "/contacts",
          LeadsShow: true
        },
        {
          text: "Tasks List",
          icon: "icons/tasks-list-svgrepo-com.svg",
          link: "/tasks",
          LeadsShow: true
        },
        {
          text: "Call Logs List",
          icon: "icons/call-svgrepo-com.svg",
          link: "/callLogs",
          LeadsShow: true
        },
        {
          text: "Bookings List",
          icon: "icons/book-svgrepo-com.svg",
          link: "/booking",
          LeadsShow: true
        },
        {
          text: "Sorted list ",
          icon: "icons/book-svgrepo-com.svg",
          link: "/sorted",
          LeadsShow: true
        },
      ]
    },
    {
      text: "Configuration",
      icon: "icons/contacts-svgrepo-com.svg",
      link: "/headers",
      subMenu: [
        {
          text: "Headers",
          icon: "icons/credit-card-svgrepo-com.svg",
          link: "/headers",
          ConfigurationShow: true
        },
        {
          text: "Projects List",
          icon: "icons/buildings-svgrepo-com.svg",
          link: "/projects",
          ConfigurationShow: true
        },
        {
          text: "API List",
          icon: "icons/cloud-upload-svgrepo-com.svg",
          link: "/apis",
          ConfigurationShow: true
        },
        {
          text: "Booking Form",
          icon: "icons/config-file.svg",
          link: "/bookingForm",
          ConfigurationShow: true
        },
        {
          text: "Resources",
          icon: "icons/earth-svgrepo-com.svg",
          link: "/resources",
          ConfigurationShow: true
        },
        {
          text: "Whatsapp API",
          icon: "icons/cloud-upload-svgrepo-com.svg",
          link: "/whatsAppIntegration",
          ConfigurationShow: true
        }
      ]
    },
    {
      text: "Support",
      icon: "icons/contacts-svgrepo-com.svg",
      link: "/news",
      subMenu: [
        {
          text: "News List",
          icon: "icons/news-svgrepo-com.svg",
          link: "/news",
          SupportShow: true
        },
        {
          text: "FAQ List",
          icon: "icons/about-faq-help-question-svgrepo-com.svg",
          link: "/faq",
          SupportShow: true
        }
      ]
    },
    {
      text: "Account & Settings",
      icon: "icons/contacts-svgrepo-com.svg",
      link: "/addCost",
      subMenu: [
        {
          text: "Licenses Cost",
          icon: "icons/book-svgrepo-com.svg",
          link: "/addCost",
          SettingsShow: true
        },
        {
          text: "Coupon",
          icon: "icons/days-config.svg",
          link: "/couponlist",
          SettingsShow: true
        },
        {
          text: "Update Password",
          icon: "icons/password-svgrepo-com.svg",
          link: "/updatePassword",
          SettingsShow: true
        },
      ]
    }
  ];

  const orgAdminMenu = [
    {
      text: "Analytics",
      icon: "icons/analytics-svgrepo-com.svg",
      link: "/analytics",
      subMenu: [
        {
          text: "Contacts Analytics",
          icon: "icons/data-analytics.png",
          panel: "Contacts",
          AnalyticShow: true
        },
        {
          text: "Tasks Analytics",
          icon: "icons/data-analytics.png",
          panel: "Tasks",
          AnalyticShow: true
        },
        {
          text: "Call Logs Analytics",
          icon: "icons/data-analytics.png",
          panel: "Call Logs",
          AnalyticShow: true
        }

      ]
    },
    {
      text: "Users",
      icon: "icons/people-svgrepo-com.svg",
      link: "/",
    },
    {
      text: "Leads",
      icon: "icons/contacts-svgrepo-com.svg",
      link: "/contacts",
      subMenu: [
        {
          text: "Contacts List",
          icon: "icons/logicIcon.png",
          link: "/contacts",
          LeadsShow: true
        },
        {
          text: "Tasks List",
          icon: "icons/tasks-list-svgrepo-com.svg",
          link: "/tasks",
          LeadsShow: true
        },
        {
          text: "Call Logs List",
          icon: "icons/call-svgrepo-com.svg",
          link: "/callLogs",
          LeadsShow: true
        },
        {
          text: "Bookings List",
          icon: "icons/book-svgrepo-com.svg",
          link: "/booking",
          LeadsShow: true
        },
      ]
    },
    {
      text: "Configuration",
      icon: "icons/contacts-svgrepo-com.svg",
      link: "/projects",
      subMenu: [
        {
          text: "Projects List",
          icon: "icons/buildings-svgrepo-com.svg",
          link: "/projects",
          ConfigurationShow: true
        },
        {
          text: "WhatsApp List",
          icon: "icons/cloud-upload-svgrepo-com.svg",
          link: "/whatsAppIntegration",
          ConfigurationShow: true
        },
        {
          text: "Resources",
          icon: "icons/earth-svgrepo-com.svg",
          link: "/resources",
          ConfigurationShow: true
        },
        {
          text: "Holiday Config",
          icon: "icons/config-file.svg",
          link: "/holidayConfig",
          ConfigurationShow: true
        },
        {
          text: "Days Config",
          icon: "icons/days-config.svg",
          link: "/daysConfig",
          ConfigurationShow: true
        }
       
      ]
    },
    {
      text: "Integrations & API",
      icon: "icons/contacts-svgrepo-com.svg",
      link: "/integrations",
      subMenu: [
        {
          text: "Integrations",
          icon: "icons/iconsintgration.png",
          link: "/integrations",
          IntegrationShow: true
        },
        {
          text: "API List",
          icon: "icons/cloud-upload-svgrepo-com.svg",
          link: "/apis",
          IntegrationShow: true
        },
        {
          text: "API Data",
          icon: "icons/cloud-upload-svgrepo-com.svg",
          link: "/apiData",
          IntegrationShow: true
        }
      ]
    },
    {
      text: "Lead Distribution",
      icon: "icons/people-svgrepo-com.svg",
      link: "/leadDistributor",
      subMenu: [
        {
          text: "Lead Distribution List",
          icon: "icons/listIcon.png",
          link: "/leadDistributor",
          DistributorShow: true
        },
        {
          text: "Lead Distribution Logic",
          icon: "icons/logicIcon.png",
          link: "/leadDistributorLogic",
          DistributorShow: true
        },
        {
          text: "Reassign List",
          icon: "icons/config-file.svg",
          link: "/reassignList",
          DistributorShow: true
        },
        {
          text: "Reassign Logic",
          icon: "icons/days-config.svg",
          link: "/reassignLogic",
          DistributorShow: true
        }
      ]
    },
    {
      text: "Support",
      icon: "icons/contacts-svgrepo-com.svg",
      link: "/news",
      subMenu: [
        {
          text: "News List",
          icon: "icons/news-svgrepo-com.svg",
          link: "/news",
          SupportShow: true
        },
        {
          text: "FAQ List",
          icon: "icons/about-faq-help-question-svgrepo-com.svg",
          link: "/faq",
          SupportShow: true
        },
        {
          text: "Help & Support",
          icon: "icons/credit-card-svgrepo-com.svg",
          link: "/viewHelpSupport",
          SupportShow: true
        },
      ]
    },
    {
      text: "Account & Settings",
      icon: "icons/contacts-svgrepo-com.svg",
      link: "/subscriptionDetails",
      subMenu: [
        {
          text: "Subscription",
          icon: "icons/credit-card-svgrepo-com.svg",
          link: "/subscriptionDetails",
          SettingsShow: true
        },
        {
          text: "Update Password",
          icon: "icons/password-svgrepo-com.svg",
          link: "/updateUserPassword",
          SettingsShow: true
        },
      ]
    },
  ]

  const salesMenu = [
    {
      text: "Analytics",
      icon: "icons/analytics-svgrepo-com.svg",
      link: "/analytics",
      subMenu: [
        {
          text: "Contacts Analytics",
          icon: "icons/data-analytics.png",
          panel: "Contacts"
        },
        {
          text: "Tasks Analytics",
          icon: "icons/data-analytics.png",
          panel: "Tasks"
        },
        {
          text: "Call Logs Analytics",
          icon: "icons/data-analytics.png",
          panel: "Call Logs"
        }

      ]
    },
    {
      text: "Leads",
      icon: "icons/contacts-svgrepo-com.svg",
      link: "/",
      subMenu: [
        {
          text: "Contacts List",
          icon: "icons/logicIcon.png",
          link: "/",
          LeadsShow: true
        },
        {
          text: "Tasks List",
          icon: "icons/tasks-list-svgrepo-com.svg",
          link: "/tasks",
          LeadsShow: true
        },
        {
          text: "Call Logs List",
          icon: "icons/call-svgrepo-com.svg",
          link: "/callLogs",
          LeadsShow: true
        },
        {
          text: "Bookings List",
          icon: "icons/book-svgrepo-com.svg",
          link: "/booking",
          LeadsShow: true
        },
      ]
    },
    {
      text: "Support",
      icon: "icons/contacts-svgrepo-com.svg",
      link: "/viewHelpSupport",
      subMenu: [
        {
          text: "Help & Support",
          icon: "icons/credit-card-svgrepo-com.svg",
          link: "/viewHelpSupport",
          SupportShow: true
        },
      ]
    },
    {
      text: "Important Tools",
      icon: "icons/contacts-svgrepo-com.svg",
      link: "/areaConverter",
      subMenu: [
        {
          text: "Area Converter",
          icon: "icons/covarea-removebg-preview.png",
          link: "/areaConverter",
          ImportantShow: true
        },
        {
          text: "Calculator",
          icon: "icons/cal-removebg-preview.png",
          link: "/calculator",
          ImportantShow: true
        },
        {
          text: "EMI Calculator",
          icon: "icons/emi.png",
          link: "/emiCalculator",
          ImportantShow: true
        }
      ]
    }
  ];

  const teamLeadMenu = [
    {
      text: "Analytics",
      icon: "icons/analytics-svgrepo-com.svg",
      link: "/analytics",
      subMenu: [
        {
          text: "Contacts Analytics",
          icon: "icons/data-analytics.png",
          panel: "Contacts"
        },
        {
          text: "Tasks Analytics",
          icon: "icons/data-analytics.png",
          panel: "Tasks"
        },
        {
          text: "Call Logs Analytics",
          icon: "icons/data-analytics.png",
          panel: "Call Logs"
        }

      ]
    },
    {
      text: "Leads",
      icon: "icons/contacts-svgrepo-com.svg",
      link: "/",
      subMenu: [
        {
          text: "Contacts List",
          icon: "icons/logicIcon.png",
          link: "/",
          LeadsShow: true
        },
        {
          text: "Tasks List",
          icon: "icons/tasks-list-svgrepo-com.svg",
          link: "/tasks",
          LeadsShow: true
        },
        {
          text: "Call Logs List",
          icon: "icons/call-svgrepo-com.svg",
          link: "/callLogs",
          LeadsShow: true
        },
        {
          text: "Bookings List",
          icon: "icons/book-svgrepo-com.svg",
          link: "/booking",
          LeadsShow: true
        },
      ]
    },
    {
      text: "Support",
      icon: "icons/contacts-svgrepo-com.svg",
      link: "/viewHelpSupport",
      subMenu: [
        {
          text: "Help & Support",
          icon: "icons/credit-card-svgrepo-com.svg",
          link: "/viewHelpSupport",
          SupportShow: true
        },
      ]
    },
    {
      text: "Important Tools",
      icon: "icons/contacts-svgrepo-com.svg",
      link: "/areaConverter",
      subMenu: [
        {
          text: "Area Converter",
          icon: "icons/covarea-removebg-preview.png",
          link: "/areaConverter",
          ImportantShow: true
        },
        {
          text: "Calculator",
          icon: "icons/cal-removebg-preview.png",
          link: "/calculator",
          ImportantShow: true
        },
        {
          text: "EMI Calculator",
          icon: "icons/emi.png",
          link: "/emiCalculator",
          ImportantShow: true
        }
      ]
    }
  ];

  const omMenu = [
    {
      text: "Bookings",
      icon: "icons/book-svgrepo-com.svg",
      link: "/",
    },
    {
      text: "Area Converter",
      icon: "icons/covarea-removebg-preview.png",
      link: "/areaConverter",
    },
    {
      text: "Calculator",
      icon: "icons/cal-removebg-preview.png",
      link: "/calculator",
    },
    {
      text: "EMI Calculator",
      icon: "icons/emi.png",
      link: "/emiCalculator",
    }
  ];

  const handleSubMenu = (text) => {
    if (text === "Contacts Analytics") {
      setUserPanel('Contacts');
      dispatcher(setAnalyticsPanel("Contacts"));
    } else if (text === "Tasks Analytics") {
      setUserPanel('Tasks');
      dispatcher(setAnalyticsPanel("Tasks"));
    } else if (text === "Call Logs Analytics") {
      setUserPanel('Call Logs');
      dispatcher(setAnalyticsPanel("Call Logs"));
    }
  }
  const handleSubBarOrg = (text) => {
    if (text === "Analytics") {
      setAnalyticsOpen(!analyticsOpen);
      setLeadDistributorOpen(false);
    } else if (text === "Lead Distribution") {
      setLeadDistributorOpen(!leadDistributorOpen);
      setAnalyticsOpen(false);
    } else {
      setAnalyticsOpen(false);
      setLeadDistributorOpen(false);
    }
  };

  // Helper to handle menu item click and auto-close sidebar on mobile
  const handleMenuItemClick = (callback) => {
    if (typeof callback === 'function') callback();
    if (props.onMenuItemClick) props.onMenuItemClick();
  };

  return (
    <div
      className={open ? "side-container" : "side-container side-container-NX"}
      style={{ backgroundColor: props.Tcolor.backgroundColor }}
    >
      <div className="nav-upper">
        {/* Logo/Header: Fixed, not scrollable */}
        <div
          className="nav-heading"
          style={{
            overflow: "hidden",
            position: "fixed",
            width: open ? "220px" : "70px", // adjust width as per your side nav width
            zIndex: 2,
            marginRight: open ? "70px" : "20px",
            marginTop: open ? "10px" : "-18px",
            paddingTop: "10px",
            paddingBottom: "10px"
          }}
        >
          {open ? <>
            <img src={LeadRubixLogo} alt="logo" style={{ height: 28, width: "auto" }} />
          </> :
            <>
              <img src={ShortLeadsRUbixLogo1} alt="logo" style={{ height: 67, width: "auto" }} />
            </>}
        </div>
        {/* Scrollable menu/list */}
        <div
          className="nav-menu"
          style={{
            marginBottom: "10px",
            marginTop: "55px",
            paddingTop: "60px",
            maxHeight: `calc(100vh - 60px)`,
            overflowY: open ? "auto" : "unset",
          }}
        >
          {props.user === "Lead Manager"
            ? leadMenu.map(({ text, icon, link, subMenu }) => (
              <>
                <Link
                  to={link}
                  className={open ? "menu-item" : "menu-item menu-item-NX"}
                  style={{
                    color: props.pathname === link ||
                      (props.pathname === "/tasks" && link === "/") ||
                      (props.pathname === "/callLogs" && link === "/") ||
                      (props.pathname === "/booking" && link === "/") ||
                      (props.pathname === "/faq" && link === "/news") ||
                      (props.pathname === "/viewHelpSupport" && link === "/news") ||
                      (props.pathname === "/calculator" && link === "/areaConverter") ||
                      (props.pathname === "/emiCalculator" && link === "/areaConverter")
                      ? "rgb(0, 0, 0)" : "white",
                    backgroundColor: props.pathname === link ||
                      (props.pathname === "/tasks" && link === "/") ||
                      (props.pathname === "/callLogs" && link === "/") ||
                      (props.pathname === "/booking" && link === "/") ||
                      (props.pathname === "/faq" && link === "/news") ||
                      (props.pathname === "/viewHelpSupport" && link === "/news") ||
                      (props.pathname === "/calculator" && link === "/areaConverter") ||
                      (props.pathname === "/emiCalculator" && link === "/areaConverter")
                      ? "white" : "",
                    display: "flex", alignItems: "center"
                  }}
                  onClick={() => handleMenuItemClick(() => text === "Analytics" ? setAnalyticsOpen(!analyticsOpen) : setAnalyticsOpen(false))}
                >
                  <img
                    className={props.Tcolor.color === "#fff" ?
                      props.pathname === link ||
                        (props.pathname === "/tasks" && link === "/") ||
                        (props.pathname === "/callLogs" && link === "/") ||
                        (props.pathname === "/booking" && link === "/") ||
                        (props.pathname === "/faq" && link === "/news") ||
                        (props.pathname === "/viewHelpSupport" && link === "/news") ||
                        (props.pathname === "/calculator" && link === "/areaConverter") ||
                        (props.pathname === "/emiCalculator" && link === "/areaConverter")
                        ? "rgb(0, 0, 0)" : "white-img" :
                      props.pathname === link ||
                        (props.pathname === "/tasks" && link === "/") ||
                        (props.pathname === "/callLogs" && link === "/") ||
                        (props.pathname === "/booking" && link === "/") ||
                        (props.pathname === "/faq" && link === "/news") ||
                        (props.pathname === "/viewHelpSupport" && link === "/news") ||
                        (props.pathname === "/calculator" && link === "/areaConverter") ||
                        (props.pathname === "/emiCalculator" && link === "/areaConverter") ? "rgb(0, 0, 0)" : "white-img"}
                    src={icon}
                    alt=""
                    style={{ width: 18, height: 18 }}
                  />
                  {open && (
                    <div className="menu-text-with-icon" style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%" }}>
                      <span style={{ flex: 1, textAlign: "left", marginLeft: "10px" }}>{text}</span>
                      {text === "Analytics" && (
                        <span className="menu-arrow-icon" style={{ marginLeft: "auto", marginRight: "5px" }}>
                          {analyticsOpen ? <FaChevronDown size={10} /> : <FaChevronRight size={10} />}
                        </span>
                      )}
                    </div>
                  )}
                </Link>
                {/* Submenu for Analytics */}
                {subMenu && open && analyticsOpen && text === "Analytics" && (
                  <div style={{ paddingBottom: "20%", textAlign: "left", marginTop: "-23%" }}>
                    {subMenu.map(({ text, icon, panel }) => (
                      <>
                        <p
                          className="submenu"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer",
                            marginBottom: "0.8rem"
                          }}
                          onClick={() => handleMenuItemClick(() => handleSubMenu(text))}
                        >
                          <img
                            src={icon}
                            alt={text}
                            width={14}
                            style={{ filter: "invert(1)", marginRight: "8px" }}
                          />
                          {text}
                        </p>
                        {userPanel === panel && <span className="line"></span>}
                      </>
                    ))}
                  </div>
                )}
                {/* Submenu for Leads List */}
                {subMenu && open && text === "Leads" && (
                  <div style={{ paddingBottom: "20%", textAlign: "left", marginTop: leadsOpen ? "-23%" : "-25%" }}>
                    {subMenu.map(({ text, icon, link, LeadsShow }) => (
                      <>
                        {LeadsShow && (
                          <>
                            <p
                              className="submenu"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                                marginBottom: "0.8rem",
                              }}
                              onClick={() => handleMenuItemClick(() => handleSubMenu(text))}
                            >
                              <img src={icon} alt={text} width={14} style={{ filter: "invert(1)", marginRight: "8px" }} />
                              <span onClick={() => history.push(link)}>{text}</span>
                            </p>
                            {link === history.location.pathname && <span className="line3"></span>}
                          </>
                        )}
                      </>
                    ))}
                  </div>
                )}
                {/* Submenu for Help & Support */}
                {subMenu && open && text === "Support" && (
                  <div style={{ paddingBottom: "20%", textAlign: "left", marginTop: supportOpen ? "-23%" : "-25%" }}>
                    {subMenu.map(({ text, icon, link, SupportShow }) => (
                      <>
                        {SupportShow && (
                          <>
                            <p
                              className="submenu"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                                marginBottom: "0.8rem",
                              }}
                              onClick={() => handleMenuItemClick(() => handleSubMenu(text))}
                            >
                              <img src={icon} alt={text} width={14} style={{ filter: "invert(1)", marginRight: "8px" }} />
                              <span onClick={() => history.push(link)}>{text}</span>
                            </p>
                            {link === history.location.pathname && <span className="line3"></span>}
                          </>
                        )}
                      </>
                    ))}
                  </div>
                )}
                {/* Submenu for Important Tools */}
                {subMenu && open && text === "Important Tools" && (
                  <div style={{ paddingBottom: "20%", textAlign: "left", marginTop: importantToolsOpen ? "-23%" : "-25%" }}>
                    {subMenu.map(({ text, icon, link, ImportantShow }) => (
                      <>
                        {ImportantShow && (
                          <>
                            <p
                              className="submenu"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                                marginBottom: "0.8rem",
                              }}
                              onClick={() => handleMenuItemClick(() => handleSubMenu(text))}
                            >
                              <img src={icon} alt={text} width={14} style={{ filter: "invert(1)", marginRight: "8px" }} />
                              <span onClick={() => history.push(link)}>{text}</span>
                            </p>
                            {link === history.location.pathname && <span className="line2"></span>}
                          </>
                        )}
                      </>
                    ))}
                  </div>
                )}
              </>
            ))
            : props.sadmin === "info@leadsrubix.com"
              ? adminMenu.map(({ text, icon, link, subMenu }) => (
                <>
                  <Link
                    to={link}
                    className={open ? "menu-item" : "menu-item menu-item-NX"}
                    style={{
                      color: props.pathname === link ||
                        (props.pathname === "/faq" && link === "/news") ||
                        (props.pathname === "/couponlist" && link === "/addCost") ||
                        (props.pathname === "/updatePassword" && link === "/addCost") ||
                        (props.pathname === "/resources" && link === "/headers") ||
                        (props.pathname === "/whatsAppIntegration" && link === "/headers") ||
                        (props.pathname === "/bookingForm" && link === "/headers") ||
                        (props.pathname === "/projects" && link === "/headers") ||
                        (props.pathname === "/apis" && link === "/headers") ||
                        (props.pathname === "/tasks" && link === "/contacts") ||
                        (props.pathname === "/callLogs" && link === "/contacts") ||
                        (props.pathname === "/booking" && link === "/contacts") ||
                        (props.pathname === "/sorted" && link === "/contacts")
                        ? "rgb(0, 0, 0)" : "white",
                      backgroundColor: props.pathname === link ||
                        (props.pathname === "/faq" && link === "/news") ||
                        (props.pathname === "/couponlist" && link === "/addCost") ||
                        (props.pathname === "/updatePassword" && link === "/addCost") ||
                        (props.pathname === "/resources" && link === "/headers") ||
                        (props.pathname === "/whatsAppIntegration" && link === "/headers") ||
                        (props.pathname === "/bookingForm" && link === "/headers") ||
                        (props.pathname === "/projects" && link === "/headers") ||
                        (props.pathname === "/apis" && link === "/headers") ||
                        (props.pathname === "/tasks" && link === "/contacts") ||
                        (props.pathname === "/callLogs" && link === "/contacts") ||
                        (props.pathname === "/booking" && link === "/contacts") ||
                        (props.pathname === "/sorted" && link === "/contacts")
                        ? "white" : "", display: "flex", alignItems: "center"
                    }}
                    onClick={() => handleMenuItemClick()}
                  >
                    <img
                      className={props.Tcolor.color === "#fff" ? props.pathname === link
                        || (props.pathname === "/faq" && link === "/news") ||
                        (props.pathname === "/couponlist" && link === "/addCost") ||
                        (props.pathname === "/updatePassword" && link === "/addCost") ||
                        (props.pathname === "/bookingForm" && link === "/headers") ||
                        (props.pathname === "/resources" && link === "/headers") ||
                        (props.pathname === "/whatsAppIntegration" && link === "/headers") ||
                        (props.pathname === "/projects" && link === "/headers") ||
                        (props.pathname === "/apis" && link === "/headers") ||
                        (props.pathname === "/tasks" && link === "/contacts") ||
                        (props.pathname === "/callLogs" && link === "/contacts") ||
                        (props.pathname === "/booking" && link === "/contacts") ||
                        (props.pathname === "/sorted" && link === "/contacts")
                        ? "rgb(0, 0, 0)" : "white-img" :
                        props.pathname === link ||
                          (props.pathname === "/faq" && link === "/news") ||
                          (props.pathname === "/couponlist" && link === "/addCost") ||
                          (props.pathname === "/updatePassword" && link === "/addCost") ||
                          (props.pathname === "/bookingForm" && link === "/headers") ||
                          (props.pathname === "/resources" && link === "/headers") ||
                          (props.pathname === "/whatsAppIntegration" && link === "/headers") ||
                          (props.pathname === "/projects" && link === "/headers") ||
                          (props.pathname === "/apis" && link === "/headers") ||
                          (props.pathname === "/tasks" && link === "/contacts") ||
                          (props.pathname === "/callLogs" && link === "/contacts") ||
                          (props.pathname === "/booking" && link === "/contacts") ||
                          (props.pathname === "/sorted" && link === "/contacts")
                          ? "rgb(0, 0, 0)" : "white-img"}
                      src={icon}
                      alt=""
                      style={{ width: 18, height: 18 }}
                    />
                    {open && (
                      <div className="menu-text-with-icon" style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%" }}>
                        <span style={{ flex: 1, textAlign: "left", marginLeft: "10px" }}>{text}</span>
                      </div>
                    )}
                  </Link>
                  {/* Submenu for Leads List */}
                  {subMenu && open && text === "Leads" && (
                    <div style={{ paddingBottom: "20%", textAlign: "left", marginTop: leadsOpen ? "-23%" : "-25%" }}>
                      {subMenu.map(({ text, icon, link, LeadsShow }) => (
                        <>
                          {LeadsShow && (
                            <>
                              <p
                                className="submenu"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  cursor: "pointer",
                                  marginBottom: "0.8rem",
                                }}
                                onClick={() => handleMenuItemClick(() => handleSubMenu(text))}
                              >
                                <img src={icon} alt={text} width={14} style={{ filter: "invert(1)", marginRight: "8px" }} />
                                <span onClick={() => history.push(link)}>{text}</span>
                              </p>
                              {link === history.location.pathname && <span className="line3"></span>}
                            </>
                          )}
                        </>
                      ))}
                    </div>
                  )}
                  {/* Submenu for Configuration List */}
                  {subMenu && open && text === "Configuration" && (
                    <div style={{ paddingBottom: "20%", textAlign: "left", marginTop: configurationOpen ? "-23%" : "-25%" }}>
                      {subMenu.map(({ text, icon, link, ConfigurationShow }) => (
                        <>
                          {ConfigurationShow && (
                            <>
                              <p
                                className="submenu"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  cursor: "pointer",
                                  marginBottom: "0.8rem",
                                }}
                                onClick={() => handleMenuItemClick(() => handleSubMenu(text))}
                              >
                                <img src={icon} alt={text} width={14} style={{ filter: "invert(1)", marginRight: "8px" }} />
                                <span onClick={() => history.push(link)}>{text}</span>
                              </p>
                              {link === history.location.pathname && <span className="line3"></span>}
                            </>
                          )}
                        </>
                      ))}
                    </div>
                  )}
                  {/* Submenu for Help & Support */}
                  {subMenu && open && text === "Support" && (
                    <div style={{ paddingBottom: "20%", textAlign: "left", marginTop: supportOpen ? "-23%" : "-25%" }}>
                      {subMenu.map(({ text, icon, link, SupportShow }) => (
                        <>
                          {SupportShow && (
                            <>
                              <p
                                className="submenu"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  cursor: "pointer",
                                  marginBottom: "0.8rem",
                                }}
                                onClick={() => handleMenuItemClick(() => handleSubMenu(text))}
                              >
                                <img src={icon} alt={text} width={14} style={{ filter: "invert(1)", marginRight: "8px" }} />
                                <span onClick={() => history.push(link)}>{text}</span>
                              </p>
                              {link === history.location.pathname && <span className="line3"></span>}
                            </>
                          )}
                        </>
                      ))}
                    </div>
                  )}
                  {/* Submenu for  Account & Settings */}
                  {subMenu && open && text === "Account & Settings" && (
                    <div style={{ paddingBottom: "20%", textAlign: "left", marginTop: settingsOpen ? "-23%" : "-25%" }}>
                      {subMenu.map(({ text, icon, link, SettingsShow }) => (
                        <>
                          {SettingsShow && (
                            <>
                              <p
                                className="submenu"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  cursor: "pointer",
                                  marginBottom: "0.8rem",
                                }}
                                onClick={() => handleMenuItemClick(() => handleSubMenu(text))}
                              >
                                <img src={icon} alt={text} width={14} style={{ filter: "invert(1)", marginRight: "8px" }} />
                                <span onClick={() => history.push(link)}>{text}</span>
                              </p>
                              {link === history.location.pathname && <span className="line2"></span>}
                            </>
                          )}
                        </>
                      ))}
                    </div>
                  )}
                </>
              ))
              : props.sadmin === "team@leadsrubix.com"
                ? replicateAdminMenu.map(({ text, icon, link, subMenu }) => (
                  <>
                    <Link
                      to={link}
                      className={open ? "menu-item" : "menu-item menu-item-NX"}
                      style={{
                        color: props.pathname === link ||
                          (props.pathname === "/tasks" && link === "/") ||
                          (props.pathname === "/callLogs" && link === "/") ||
                          (props.pathname === "/booking" && link === "/") ||
                          (props.pathname === "/sorted" && link === "/") ||
                          (props.pathname === "/apis" && link === "/projects")
                          ? "rgb(0, 0, 0)" : "white",
                        backgroundColor: props.pathname === link ||
                          (props.pathname === "/tasks" && link === "/") ||
                          (props.pathname === "/callLogs" && link === "/") ||
                          (props.pathname === "/booking" && link === "/") ||
                          (props.pathname === "/sorted" && link === "/") ||
                          (props.pathname === "/apis" && link === "/projects")
                          ? "white" : "", display: "flex", alignItems: "center"
                      }}
                      onClick={() => handleMenuItemClick()}
                    >
                      <img
                        className={props.Tcolor.color === "#fff" ? props.pathname === link ||
                          (props.pathname === "/tasks" && link === "/") ||
                          (props.pathname === "/callLogs" && link === "/") ||
                          (props.pathname === "/booking" && link === "/") ||
                          (props.pathname === "/sorted" && link === "/") ||
                          (props.pathname === "/apis" && link === "/project")
                          ? "rgb(0, 0, 0)" : "white-img" :
                          props.pathname === link ||
                            (props.pathname === "/tasks" && link === "/") ||
                            (props.pathname === "/callLogs" && link === "/") ||
                            (props.pathname === "/booking" && link === "/") ||
                            (props.pathname === "/sorted" && link === "/") ||
                            (props.pathname === "/apis" && link === "/project")
                            ? "rgb(0, 0, 0)" : "white-img"}
                        src={icon}
                        alt=""
                        style={{ width: 18, height: 18 }}
                      />
                      {open && (
                        <div className="menu-text-with-icon" style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%" }}>
                          <span style={{ flex: 1, textAlign: "left", marginLeft: "10px" }}>{text}</span>
                        </div>
                      )}
                    </Link>
                    {/* Submenu for Leads List */}
                    {subMenu && open && text === "Leads" && (
                      <div style={{ paddingBottom: "20%", textAlign: "left", marginTop: leadsOpen ? "-23%" : "-25%" }}>
                        {subMenu.map(({ text, icon, link, LeadsShow }) => (
                          <>
                            {LeadsShow && (
                              <>
                                <p
                                  className="submenu"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    marginBottom: "0.8rem",
                                  }}
                                  onClick={() => handleMenuItemClick(() => handleSubMenu(text))}
                                >
                                  <img src={icon} alt={text} width={14} style={{ filter: "invert(1)", marginRight: "8px" }} />
                                  <span onClick={() => history.push(link)}>{text}</span>
                                </p>
                                {link === history.location.pathname && <span className="line3"></span>}
                              </>
                            )}
                          </>
                        ))}
                      </div>
                    )}
                    {/* Submenu for Configuration List */}
                    {subMenu && open && text === "Configuration" && (
                      <div style={{ paddingBottom: "20%", textAlign: "left", marginTop: configurationOpen ? "-23%" : "-25%" }}>
                        {subMenu.map(({ text, icon, link, ConfigurationShow }) => (
                          <>
                            {ConfigurationShow && (
                              <>
                                <p
                                  className="submenu"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    marginBottom: "0.8rem",
                                  }}
                                  onClick={() => handleMenuItemClick(() => handleSubMenu(text))}
                                >
                                  <img src={icon} alt={text} width={14} style={{ filter: "invert(1)", marginRight: "8px" }} />
                                  <span onClick={() => history.push(link)}>{text}</span>
                                </p>
                                {link === history.location.pathname && <span className="line3"></span>}
                              </>
                            )}
                          </>
                        ))}
                      </div>
                    )}
                    {/* Submenu for Help & Support */}
                    {subMenu && open && text === "Support" && (
                      <div style={{ paddingBottom: "20%", textAlign: "left", marginTop: supportOpen ? "-23%" : "-25%" }}>
                        {subMenu.map(({ text, icon, link, SupportShow }) => (
                          <>
                            {SupportShow && (
                              <>
                                <p
                                  className="submenu"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    marginBottom: "0.8rem",
                                  }}
                                  onClick={() => handleMenuItemClick(() => handleSubMenu(text))}
                                >
                                  <img src={icon} alt={text} width={14} style={{ filter: "invert(1)", marginRight: "8px" }} />
                                  <span onClick={() => history.push(link)}>{text}</span>
                                </p>
                                {link === history.location.pathname && <span className="line3"></span>}
                              </>
                            )}
                          </>
                        ))}
                      </div>
                    )}
                  </>
                ))
                : props.user === "Sales"
                  ? salesMenu.map(({ text, icon, link, subMenu }) => (
                    <>
                      <Link
                        to={link}
                        className={open ? "menu-item" : "menu-item menu-item-NX"}
                        style={{
                          color: props.pathname === link ||
                            (props.pathname === "/tasks" && link === "/") ||
                            (props.pathname === "/callLogs" && link === "/") ||
                            (props.pathname === "/booking" && link === "/") ||
                            (props.pathname === "/calculator" && link === "/areaConverter") ||
                            (props.pathname === "/emiCalculator" && link === "/areaConverter") ? "rgb(0, 0, 0)" : "white",
                          backgroundColor: props.pathname === link ||
                            (props.pathname === "/tasks" && link === "/") ||
                            (props.pathname === "/callLogs" && link === "/") ||
                            (props.pathname === "/booking" && link === "/") ||
                            (props.pathname === "/calculator" && link === "/areaConverter") ||
                            (props.pathname === "/emiCalculator" && link === "/areaConverter") ?
                            "white" : "", display: "flex", alignItems: "center"
                        }}
                        onClick={() => handleMenuItemClick(() => text === "Analytics" ? setAnalyticsOpen(!analyticsOpen) : setAnalyticsOpen(false))}
                      >
                        <img
                          className={props.Tcolor.color === "#fff" ?
                            props.pathname === link ||
                              (props.pathname === "/tasks" && link === "/") ||
                              (props.pathname === "/callLogs" && link === "/") ||
                              (props.pathname === "/booking" && link === "/") ||
                              (props.pathname === "/calculator" && link === "/areaConverter") ||
                              (props.pathname === "/emiCalculator" && link === "/areaConverter")
                              ? "rgb(0, 0, 0)" : "white-img" :
                            props.pathname === link ||
                              (props.pathname === "/tasks" && link === "/") ||
                              (props.pathname === "/callLogs" && link === "/") ||
                              (props.pathname === "/booking" && link === "/") ||
                              (props.pathname === "/calculator" && link === "/areaConverter") ||
                              (props.pathname === "/emiCalculator" && link === "/areaConverter")
                              ? "rgb(0, 0, 0)" : "white-img"}
                          src={icon}
                          alt=""
                          style={{ width: 18, height: 18 }}
                        />
                        {open && (
                          <div className="menu-text-with-icon" style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%" }}>
                            <span style={{ flex: 1, textAlign: "left", marginLeft: "10px" }}>{text}</span>
                            {text === "Analytics" && (
                              <span className="menu-arrow-icon" style={{ marginLeft: "auto", marginRight: "5px" }}>
                                {analyticsOpen ? <FaChevronDown size={10} /> : <FaChevronRight size={10} />}
                              </span>
                            )}
                          </div>
                        )}
                      </Link>
                      {/* Submenu for Analytics */}
                      {subMenu && open && analyticsOpen && text === "Analytics" && (
                        <div style={{ paddingBottom: "20%", textAlign: "left", marginTop: "-23%" }}>
                          {subMenu.map(({ text, icon, panel }) => (
                            <>
                              <p
                                className="submenu"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  cursor: "pointer",
                                  marginBottom: "0.8rem",
                                }} onClick={() => handleMenuItemClick(() => handleSubMenu(text))} >
                                <img
                                  src={icon}
                                  alt={text}
                                  width={14}
                                  style={{ filter: "invert(1)", marginRight: "8px" }}
                                />
                                {text}
                              </p>
                              {userPanel === panel && <span className="line"></span>}
                            </>
                          ))}
                        </div>
                      )}
                      {/* Submenu for Leads List */}
                      {subMenu && open && text === "Leads" && (
                        <div style={{ paddingBottom: "20%", textAlign: "left", marginTop: leadsOpen ? "-23%" : "-25%" }}>
                          {subMenu.map(({ text, icon, link, LeadsShow }) => (
                            <>
                              {LeadsShow && (
                                <>
                                  <p
                                    className="submenu"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      cursor: "pointer",
                                      marginBottom: "0.8rem",
                                    }}
                                    onClick={() => handleMenuItemClick(() => handleSubMenu(text))}
                                  >
                                    <img src={icon} alt={text} width={14} style={{ filter: "invert(1)", marginRight: "8px" }} />
                                    <span onClick={() => history.push(link)}>{text}</span>
                                  </p>
                                  {link === history.location.pathname && <span className="line3"></span>}
                                </>
                              )}
                            </>
                          ))}
                        </div>
                      )}
                      {/* Submenu for Help & Support */}
                      {subMenu && open && text === "Support" && (
                        <div style={{ paddingBottom: "20%", textAlign: "left", marginTop: supportOpen ? "-23%" : "-25%" }}>
                          {subMenu.map(({ text, icon, link, SupportShow }) => (
                            <>
                              {SupportShow && (
                                <>
                                  <p
                                    className="submenu"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      cursor: "pointer",
                                      marginBottom: "0.8rem",
                                    }}
                                    onClick={() => handleMenuItemClick(() => handleSubMenu(text))}
                                  >
                                    <img src={icon} alt={text} width={14} style={{ filter: "invert(1)", marginRight: "8px" }} />
                                    <span onClick={() => history.push(link)}>{text}</span>
                                  </p>
                                  {link === history.location.pathname && <span className="line3"></span>}
                                </>
                              )}
                            </>
                          ))}
                        </div>
                      )}
                      {/* Submenu for Important Tools */}
                      {subMenu && open && text === "Important Tools" && (
                        <div style={{ paddingBottom: "20%", textAlign: "left", marginTop: importantToolsOpen ? "-23%" : "-25%" }}>
                          {subMenu.map(({ text, icon, link, ImportantShow }) => (
                            <>
                              {ImportantShow && (
                                <>
                                  <p
                                    className="submenu"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      cursor: "pointer",
                                      marginBottom: "0.8rem",
                                    }}
                                    onClick={() => handleMenuItemClick(() => handleSubMenu(text))}
                                  >
                                    <img src={icon} alt={text} width={14} style={{ filter: "invert(1)", marginRight: "8px" }} />
                                    <span onClick={() => history.push(link)}>{text}</span>
                                  </p>
                                  {link === history.location.pathname && <span className="line2"></span>}
                                </>
                              )}
                            </>
                          ))}
                        </div>
                      )}
                    </>
                  ))
                  : props.user === "Team Lead"
                    ? teamLeadMenu.map(({ text, icon, link, subMenu }) => (
                      <>
                        <Link
                          to={link}
                          className={open ? "menu-item" : "menu-item menu-item-NX"}
                          style={{
                            color: props.pathname === link ||
                              (props.pathname === "/tasks" && link === "/") ||
                              (props.pathname === "/callLogs" && link === "/") ||
                              (props.pathname === "/booking" && link === "/") ||
                              (props.pathname === "/calculator" && link === "/areaConverter") ||
                              (props.pathname === "/emiCalculator" && link === "/areaConverter") ? "rgb(0, 0, 0)" : "white",
                            backgroundColor: props.pathname === link ||
                              (props.pathname === "/tasks" && link === "/") ||
                              (props.pathname === "/callLogs" && link === "/") ||
                              (props.pathname === "/booking" && link === "/") ||
                              (props.pathname === "/calculator" && link === "/areaConverter") ||
                              (props.pathname === "/emiCalculator" && link === "/areaConverter") ?
                              "white" : "", display: "flex", alignItems: "center"
                          }}
                          onClick={() => handleMenuItemClick(() => text === "Analytics" ? setAnalyticsOpen(!analyticsOpen) : setAnalyticsOpen(false))}
                        >
                          <img
                            className={props.Tcolor.color === "#fff" ?
                              props.pathname === link ||
                                (props.pathname === "/tasks" && link === "/") ||
                                (props.pathname === "/callLogs" && link === "/") ||
                                (props.pathname === "/booking" && link === "/") ||
                                (props.pathname === "/calculator" && link === "/areaConverter") ||
                                (props.pathname === "/emiCalculator" && link === "/areaConverter")
                                ? "rgb(0, 0, 0)" : "white-img" :
                              props.pathname === link ||
                                (props.pathname === "/tasks" && link === "/") ||
                                (props.pathname === "/callLogs" && link === "/") ||
                                (props.pathname === "/booking" && link === "/") ||
                                (props.pathname === "/calculator" && link === "/areaConverter") ||
                                (props.pathname === "/emiCalculator" && link === "/areaConverter")
                                ? "rgb(0, 0, 0)" : "white-img"}
                            src={icon}
                            alt=""
                            style={{ width: 18, height: 18 }}
                          />
                          {open && (
                            <div className="menu-text-with-icon" style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%" }}>
                              <span style={{ flex: 1, textAlign: "left", marginLeft: "10px" }}>{text}</span>
                              {text === "Analytics" && (
                                <span className="menu-arrow-icon">
                                  {analyticsOpen ? <FaChevronDown size={10} /> : <FaChevronRight size={10} />}
                                </span>
                              )}
                            </div>
                          )}
                        </Link>
                        {/* Submenu for Analytics */}
                        {subMenu && open && analyticsOpen && text === "Analytics" && (
                          <div style={{ paddingBottom: "20%", textAlign: "left", marginTop: "-23%" }}>
                            {subMenu.map(({ text, icon, panel }) => (
                              <>
                                <p
                                  className="submenu"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    cursor: "pointer",
                                  }} onClick={() => handleMenuItemClick(() => handleSubMenu(text))} >
                                  <img
                                    src={icon}
                                    alt={text}
                                    width={14}
                                    style={{ filter: "invert(1)", marginRight: "8px" }} // Make icon white and add spacing
                                  />
                                  {text}
                                </p>
                                {userPanel === panel && <span className="line"></span>}
                              </>
                            ))}
                          </div>
                        )}
                        {/* Submenu for Leads List */}
                        {subMenu && open && text === "Leads" && (
                          <div style={{ paddingBottom: "20%", textAlign: "left", marginTop: leadsOpen ? "-23%" : "-25%" }}>
                            {subMenu.map(({ text, icon, link, LeadsShow }) => (
                              <>
                                {LeadsShow && (
                                  <>
                                    <p
                                      className="submenu"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        cursor: "pointer",
                                        marginBottom: "0.8rem",
                                      }}
                                      onClick={() => handleMenuItemClick(() => handleSubMenu(text))}
                                    >
                                      <img src={icon} alt={text} width={14} style={{ filter: "invert(1)", marginRight: "8px" }} />
                                      <span onClick={() => history.push(link)}>{text}</span>
                                    </p>
                                    {link === history.location.pathname && <span className="line3"></span>}
                                  </>
                                )}
                              </>
                            ))}
                          </div>
                        )}
                        {/* Submenu for Help & Support */}
                        {subMenu && open && text === "Support" && (
                          <div style={{ paddingBottom: "20%", textAlign: "left", marginTop: supportOpen ? "-23%" : "-25%" }}>
                            {subMenu.map(({ text, icon, link, SupportShow }) => (
                              <>
                                {SupportShow && (
                                  <>
                                    <p
                                      className="submenu"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        cursor: "pointer",
                                        marginBottom: "0.8rem",
                                      }}
                                      onClick={() => handleMenuItemClick(() => handleSubMenu(text))}
                                    >
                                      <img src={icon} alt={text} width={14} style={{ filter: "invert(1)", marginRight: "8px" }} />
                                      <span onClick={() => history.push(link)}>{text}</span>
                                    </p>
                                    {link === history.location.pathname && <span className="line3"></span>}
                                  </>
                                )}
                              </>
                            ))}
                          </div>
                        )}
                        {/* Submenu for Important Tools */}
                        {subMenu && open && text === "Important Tools" && (
                          <div style={{ paddingBottom: "20%", textAlign: "left", marginTop: importantToolsOpen ? "-23%" : "-25%" }}>
                            {subMenu.map(({ text, icon, link, ImportantShow }) => (
                              <>
                                {ImportantShow && (
                                  <>
                                    <p
                                      className="submenu"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        cursor: "pointer",
                                        marginBottom: "0.8rem",
                                      }}
                                      onClick={() => handleMenuItemClick(() => handleSubMenu(text))}
                                    >
                                      <img src={icon} alt={text} width={14} style={{ filter: "invert(1)", marginRight: "8px" }} />
                                      <span onClick={() => history.push(link)}>{text}</span>
                                    </p>
                                    {link === history.location.pathname && <span className="line2"></span>}
                                  </>
                                )}
                              </>
                            ))}
                          </div>
                        )}
                      </>
                    ))
                    : props.user === "Operation Manager"
                      ? omMenu.map(({ text, icon, link }) => (
                        <Link
                          to={link}
                          className={open ? "menu-item" : "menu-item menu-item-NX"}
                          style={{ color: props.pathname === link ? "rgb(0, 0, 0)" : "white", backgroundColor: props.pathname === link ? "white" : "", display: "flex", alignItems: "center" }}
                        >
                          <img
                            className={props.Tcolor.color === "#fff" ? props.pathname === link ? "rgb(0, 0, 0)" : "white-img" : props.pathname === link ? "rgb(0, 0, 0)" : "white-img"}
                            src={icon}
                            alt=""
                            style={{ width: 18, height: 18 }}
                          />
                          {open && <p>{text}</p>}
                        </Link>
                      ))
                      : props.user !== "Lead Manager" &&
                        props.user !== "Sales" &&
                        props.user !== "Team Lead" &&
                        props.sadmin !== "info@leadsrubix.com" &&
                        props.sadmin !== "team@leadsrubix.com"
                        ? orgAdminMenu.map(({ text, icon, link, subMenu }) => (
                          <>
                            <Link
                              to={link}
                              className={open ? "menu-item" : "menu-item menu-item-NX"}
                              style={{
                                color:
                                  props.pathname === link ||
                                    (props.pathname === "/leadDistributorLogic" && link === "/leadDistributor") ||
                                    (props.pathname === "/tasks" && link === "/contacts") ||
                                    (props.pathname === "/callLogs" && link === "/contacts") ||
                                    (props.pathname === "/booking" && link === "/contacts") ||
                                    (props.pathname === "/daysConfig" && link === "/projects") ||
                                    (props.pathname === "/holidayConfig" && link === "/projects") ||
                                    (props.pathname === "/resources" && link === "/projects") ||
                                    (props.pathname === "/whatsAppIntegration" && link === "/projects") ||
                                    (props.pathname === "/simplyWhatsAppIntegration" && link === "/projects") ||
                                    (props.pathname === "/wapiWhatsAppIntegration" && link === "/projects") ||
                                    (props.pathname === "/apis" && link === "/integrations") ||
                                    (props.pathname === "/apiData" && link === "/integrations") ||
                                    (props.pathname === "/faq" && link === "/news") ||
                                    (props.pathname === "/viewHelpSupport" && link === "/news") ||
                                    (props.pathname === "/updateUserPassword" && link === "/subscriptionDetails")
                                    ? "rgb(0, 0, 0)"
                                    : "white",
                                backgroundColor:
                                  props.pathname === link ||
                                    (props.pathname === "/leadDistributorLogic" && link === "/leadDistributor") ||
                                    (props.pathname === "/tasks" && link === "/contacts") ||
                                    (props.pathname === "/callLogs" && link === "/contacts") ||
                                    (props.pathname === "/booking" && link === "/contacts") ||
                                    (props.pathname === "/daysConfig" && link === "/projects") ||
                                    (props.pathname === "/holidayConfig" && link === "/projects") ||
                                    (props.pathname === "/resources" && link === "/projects") ||
                                    (props.pathname === "/whatsAppIntegration" && link === "/projects") ||
                                    (props.pathname === "/simplyWhatsAppIntegration" && link === "/projects") ||
                                    (props.pathname === "/wapiWhatsAppIntegration" && link === "/projects") ||
                                    (props.pathname === "/apis" && link === "/integrations") ||
                                    (props.pathname === "/apiData" && link === "/integrations") ||
                                    (props.pathname === "/faq" && link === "/news") ||
                                    (props.pathname === "/viewHelpSupport" && link === "/news") ||
                                    (props.pathname === "/updateUserPassword" && link === "/subscriptionDetails")
                                    ? "white"
                                    : "",
                              }}
                              onClick={() => handleMenuItemClick(() => handleSubBarOrg(text))}
                            >
                              <img
                                className={
                                  props.Tcolor.color === "#fff"
                                    ? props.pathname === link ||
                                      (props.pathname === "/leadDistributorLogic" && link === "/leadDistributor") ||
                                      (props.pathname === "/reassignLogic" && link === "/reassignList") ||
                                      (props.pathname === "/reassignList" && link === "/reassignLogic") ||
                                      (props.pathname === "/tasks" && link === "/contacts") ||
                                      (props.pathname === "/callLogs" && link === "/contacts") ||
                                      (props.pathname === "/booking" && link === "/contacts") ||
                                      (props.pathname === "/daysConfig" && link === "/projects") ||
                                      (props.pathname === "/holidayConfig" && link === "/projects") ||
                                      (props.pathname === "/resources" && link === "/projects") ||
                                      (props.pathname === "/whatsAppIntegration" && link === "/projects") ||
                                      (props.pathname === "/simplyWhatsAppIntegration" && link === "/projects") ||
                                      (props.pathname === "/wapiWhatsAppIntegration" && link === "/projects") ||
                                      (props.pathname === "/apis" && link === "/integrations") ||
                                      (props.pathname === "/apiData" && link === "/integrations") ||
                                      (props.pathname === "/faq" && link === "/news") ||
                                      (props.pathname === "/viewHelpSupport" && link === "/news") ||
                                      (props.pathname === "/updateUserPassword" && link === "/subscriptionDetails")
                                      ? "rgb(0, 0, 0)"
                                      : "white-img"
                                    : props.pathname === link ||
                                      (props.pathname === "/leadDistributorLogic" && link === "/leadDistributor") ||
                                      (props.pathname === "/reassignLogic" && link === "/reassignList") ||
                                      (props.pathname === "/reassignList" && link === "/reassignLogic") ||
                                      (props.pathname === "/tasks" && link === "/contacts") ||
                                      (props.pathname === "/callLogs" && link === "/contacts") ||
                                      (props.pathname === "/booking" && link === "/contacts") ||
                                      (props.pathname === "/daysConfig" && link === "/projects") ||
                                      (props.pathname === "/holidayConfig" && link === "/projects") ||
                                      (props.pathname === "/whatsAppIntegration" && link === "/projects") ||
                                      (props.pathname === "/simplyWhatsAppIntegration" && link === "/projects") ||
                                      (props.pathname === "/wapiWhatsAppIntegration" && link === "/projects") ||
                                      (props.pathname === "/resources" && link === "/projects") ||
                                      (props.pathname === "/apis" && link === "/integrations") ||
                                      (props.pathname === "/apiData" && link === "/integrations") ||
                                      (props.pathname === "/faq" && link === "/news") ||
                                      (props.pathname === "/viewHelpSupport" && link === "/news") ||
                                      (props.pathname === "/updateUserPassword" && link === "/subscriptionDetails")
                                      ? "rgb(0, 0, 0)"
                                      : "white-img"
                                }
                                src={icon}
                                alt=""
                                style={{ width: 18, height: 18, marginTop: "8px" }}
                              />
                              {open && (
                                <div className="menu-text-with-icon" style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%" }}>
                                  <span style={{ flex: 1, textAlign: "left", marginLeft: "10px" }}>{text}</span>
                                  {["Analytics"].includes(text) && (
                                    <span className="menu-arrow-icon" style={{ marginLeft: "auto", marginRight: "5px" }}>
                                      {text === "Analytics" && (analyticsOpen ? <FaChevronDown size={10} /> : <FaChevronRight size={10} />)}
                                      {/* {text === "Lead Distribution" && (leadDistributorOpen ? <FaChevronDown size={10} /> : <FaChevronRight size={10} />)} */}
                                    </span>
                                  )}
                                </div>
                              )}
                            </Link>
                            {/* Submenu for Analytics */}
                            {subMenu && open && analyticsOpen && text === "Analytics" && (
                              <div style={{ paddingBottom: "20%", textAlign: "left", marginTop: "-23%" }}>
                                {subMenu.map(({ text, icon, panel, AnalyticShow }) => (
                                  <>
                                    {AnalyticShow && (
                                      <>
                                        <p
                                          className="submenu"
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            cursor: "pointer",
                                            marginBottom: "0.8rem",
                                          }}
                                          onClick={() => handleMenuItemClick(() => handleSubMenu(text))}
                                        >
                                          {/* <span style={{ color: "#fff", marginRight: "7px", lineHeight: "0.7" }}>●</span> */}
                                          <img src={icon} alt={text} width={14} style={{ filter: "invert(1)", marginRight: "8px" }} />
                                          {text}
                                        </p>
                                        {userPanel === panel && <span className="line"></span>}
                                      </>
                                    )}
                                  </>
                                ))}
                              </div>
                            )}
                            {/* Submenu for Leads List */}
                            {subMenu && open && text === "Leads" && (
                              <div style={{ paddingBottom: "20%", textAlign: "left", marginTop: leadsOpen ? "-23%" : "-25%" }}>
                                {subMenu.map(({ text, icon, link, LeadsShow }) => (
                                  <>
                                    {LeadsShow && (
                                      <>
                                        <p
                                          className="submenu"
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            cursor: "pointer",
                                            marginBottom: "0.8rem",
                                          }}
                                          onClick={() => handleMenuItemClick(() => handleSubMenu(text))}
                                        >
                                          <img src={icon} alt={text} width={14} style={{ filter: "invert(1)", marginRight: "8px" }} />
                                          <span onClick={() => history.push(link)}>{text}</span>
                                        </p>
                                        {link === history.location.pathname && <span className="line3"></span>}
                                      </>
                                    )}
                                  </>
                                ))}
                              </div>
                            )}
                            {/* Submenu for Configuration List */}
                            {subMenu && open && text === "Configuration" && (
                              <div style={{ paddingBottom: "20%", textAlign: "left", marginTop: configurationOpen ? "-23%" : "-25%" }}>
                                {subMenu.map(({ text, icon, link, ConfigurationShow }) => (
                                  <>
                                    {ConfigurationShow && (
                                      <>
                                        <p
                                          className="submenu"
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            cursor: "pointer",
                                            marginBottom: "0.8rem",
                                          }}
                                          onClick={() => handleMenuItemClick(() => handleSubMenu(text))}
                                        >
                                          <img src={icon} alt={text} width={14} style={{ filter: "invert(1)", marginRight: "8px" }} />
                                          <span onClick={() => history.push(link)}>{text}</span>
                                        </p>
                                        {link === history.location.pathname && <span className="line3"></span>}
                                      </>
                                    )}
                                  </>
                                ))}
                              </div>
                            )}
                            {/* Submenu for Lead Distribution */}
                            {subMenu && open && text === "Lead Distribution" && (
                              <div style={{ paddingBottom: "20%", textAlign: "left", marginTop: "-23%" }}>
                                {subMenu.map(({ text, icon, link, DistributorShow }) => (
                                  <>
                                    {DistributorShow && (
                                      <>
                                        <p
                                          className="submenu"
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            cursor: "pointer",
                                            marginBottom: "0.8rem",
                                          }}
                                          onClick={() => handleMenuItemClick(() => handleSubMenu(text))}
                                        >
                                          <img src={icon} alt={text} width={14} style={{ filter: "invert(1)", marginRight: "8px" }} />
                                          <span onClick={() => history.push(link)}>{text}</span>
                                        </p>
                                        {(() => {
                                          const current = history.location.pathname;
                                          const reassignPaths = ["/reassignList", "/reassignLogic"];
                                          const isSelected = link === current;
                                          if (!isSelected) return null;
                                          const cls = reassignPaths.includes(current) ? "line2" : "line";
                                          return <span className={cls}></span>;
                                        })()}
                                      </>
                                    )}
                                  </>
                                ))}
                              </div>
                            )}
                            {/* Submenu for Integrations & API */}
                            {subMenu && open && text === "Integrations & API" && (
                              <div style={{ paddingBottom: "20%", textAlign: "left", marginTop: IntegrationOpen ? "-23%" : "-25%" }}>
                                {subMenu.map(({ text, icon, link, IntegrationShow }) => (
                                  <>
                                    {IntegrationShow && (
                                      <>
                                        <p
                                          className="submenu"
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            cursor: "pointer",
                                            marginBottom: "0.8rem",
                                          }}
                                          onClick={() => handleMenuItemClick(() => handleSubMenu(text))}
                                        >
                                          <img src={icon} alt={text} width={14} style={{ filter: "invert(1)", marginRight: "8px" }} />
                                          <span onClick={() => history.push(link)}>{text}</span>
                                        </p>
                                        {link === history.location.pathname && <span className="line3"></span>}
                                      </>
                                    )}
                                  </>
                                ))}
                              </div>
                            )}
                            {/* Submenu for Help & Support */}
                            {subMenu && open && text === "Support" && (
                              <div style={{ paddingBottom: "20%", textAlign: "left", marginTop: supportOpen ? "-23%" : "-25%" }}>
                                {subMenu.map(({ text, icon, link, SupportShow }) => (
                                  <>
                                    {SupportShow && (
                                      <>
                                        <p
                                          className="submenu"
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            cursor: "pointer",
                                            marginBottom: "0.8rem",
                                          }}
                                          onClick={() => handleMenuItemClick(() => handleSubMenu(text))}
                                        >
                                          <img src={icon} alt={text} width={14} style={{ filter: "invert(1)", marginRight: "8px" }} />
                                          <span onClick={() => history.push(link)}>{text}</span>
                                        </p>
                                        {link === history.location.pathname && <span className="line3"></span>}
                                      </>
                                    )}
                                  </>
                                ))}
                              </div>
                            )}
                            {/* Submenu for  Account & Settings */}
                            {subMenu && open && text === "Account & Settings" && (
                              <div style={{ paddingBottom: "20%", textAlign: "left", marginTop: settingsOpen ? "-23%" : "-25%" }}>
                                {subMenu.map(({ text, icon, link, SettingsShow }) => (
                                  <>
                                    {SettingsShow && (
                                      <>
                                        <p
                                          className="submenu"
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            cursor: "pointer",
                                            marginBottom: "0.8rem",
                                          }}
                                          onClick={() => handleMenuItemClick(() => handleSubMenu(text))}
                                        >
                                          <img src={icon} alt={text} width={14} style={{ filter: "invert(1)", marginRight: "8px" }} />
                                          <span onClick={() => history.push(link)}>{text}</span>
                                        </p>
                                        {link === history.location.pathname && <span className="line2"></span>}
                                      </>
                                    )}
                                  </>
                                ))}
                              </div>
                            )}
                          </>
                        ))
                        : null}
        </div>
      </div>
    </div>
  );
}

export default SideNav;
